import { useState } from 'react';
import UserEntity from '../../../domain/entities/UserEntity';
import ProviderProps from '../../../domain/providers/ProviderProps';
import UserProvider from '../../../domain/providers/user/UserProvider';
import { injectable } from 'inversify';
import UserContextType from '../../../domain/providers/user/UserContextType';
import UserContext, { defaultUserContext } from './UserContext';

const _Actions: UserContextType = defaultUserContext;

const _Provider = ({ children }: ProviderProps) => {
  const [user, setUser] = useState<UserEntity | null | undefined>(undefined);
  _Actions.user = user;
  _Actions.setUser = setUser;
  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

@injectable()
class UserProviderImpl implements UserProvider {
  public context = UserContext;

  public Provider = _Provider;

  Actions = _Actions
}

export default new UserProviderImpl();

